import React, { useState } from 'react';
import logo from './asset/logo.png'
import { FileText, Scale, AlertTriangle, BookOpen, Shield, CreditCard, Users, Ban, Gavel, Mail, Menu, X, ChevronDown, ChevronUp, CheckCircle, XCircle, Info } from 'lucide-react';

const TermsOfService = () => {
  const [expandedSection, setExpandedSection] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-gray-50 to-blue-50">
      {/* Navbar */}
      <nav className="bg-black/80 backdrop-blur-md shadow-lg sticky top-0 z-50 border-b border-gray-200 " >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex items-center">
              <div className="flex items-center gap-2" sty>
               <img
                   src={logo} // replace with your image path
                   alt="Description"
                   width="100px"
                 />
              </div>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center gap-8">
              <a href="/" className="text-white-100 hover:text-blue-600 transition-colors font-medium">
                Home
              </a>
             
            </div>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-gray-700"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden py-4 space-y-3 border-t border-gray-200">
              <a href="#" className="block text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Home
              </a>
              <a href="#" className="block text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Features
              </a>
              <a href="#" className="block text-blue-600 font-semibold">
                Terms of Service
              </a>
              <a href="#" className="block text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Privacy Policy
              </a>
              <button className="w-full bg-gradient-to-r from-slate-700 to-blue-600 text-white px-6 py-2 rounded-full hover:shadow-lg transition-all duration-300 font-medium">
                Get Started
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-slate-800 via-gray-800 to-blue-800 opacity-95"></div>
        <div className="relative py-16 px-4 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-red-500/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6 border border-red-400/30">
              <AlertTriangle className="w-5 h-5 text-red-300" />
              <span className="text-sm font-semibold">Legal Agreement</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Terms of Service
            </h1>
            <p className="text-xl text-white/90 max-w-2xl mx-auto">
              Please read these terms carefully before using IEEE Paper Pro
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-4 text-sm text-white/80">
              <div className="flex items-center gap-2">
                <FileText className="w-4 h-4" />
                <span>Last Updated: January 1, 2025</span>
              </div>
              <div className="flex items-center gap-2">
                <Scale className="w-4 h-4" />
                <span>Governing Law: India</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Decorative Elements */}
        <div className="absolute top-10 left-10 w-20 h-20 bg-white/5 rounded-full blur-xl"></div>
        <div className="absolute bottom-10 right-10 w-32 h-32 bg-white/5 rounded-full blur-2xl"></div>
      </div>

      {/* Important Warning */}
      <div className="max-w-4xl mx-auto px-4 -mt-8 mb-8 relative z-10">
        <div className="bg-red-50 border-2 border-red-300 rounded-2xl shadow-xl p-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0">
              <AlertTriangle className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="text-lg font-bold text-red-900 mb-2">
                IMPORTANT: PLEASE READ CAREFULLY
              </h3>
              <p className="text-red-800 text-sm mb-2">
                By accessing or using our Service, you agree to be bound by these Terms of Service. 
                If you disagree with any part of these terms, you must not use our Service.
              </p>
              <p className="text-red-700 text-xs">
                <strong>Jurisdiction:</strong> Nagpur, Maharashtra, India
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Navigation */}
      <div className="max-w-4xl mx-auto px-4 mb-8">
        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
          <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
            <BookOpen className="w-5 h-5 text-blue-600" />
            Quick Navigation
          </h3>
          <div className="grid md:grid-cols-3 gap-3">
            <button onClick={() => toggleSection(2)} className="text-left p-3 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors">
              <p className="text-sm font-semibold text-blue-900">Service Description</p>
            </button>
            <button onClick={() => toggleSection(4)} className="text-left p-3 bg-green-50 rounded-lg hover:bg-green-100 transition-colors">
              <p className="text-sm font-semibold text-green-900">Payments & Subscriptions</p>
            </button>
            <button onClick={() => toggleSection(5)} className="text-left p-3 bg-purple-50 rounded-lg hover:bg-purple-100 transition-colors">
              <p className="text-sm font-semibold text-purple-900">Intellectual Property</p>
            </button>
            <button onClick={() => toggleSection(6)} className="text-left p-3 bg-amber-50 rounded-lg hover:bg-amber-100 transition-colors">
              <p className="text-sm font-semibold text-amber-900">User Responsibilities</p>
            </button>
            <button onClick={() => toggleSection(7)} className="text-left p-3 bg-red-50 rounded-lg hover:bg-red-100 transition-colors">
              <p className="text-sm font-semibold text-red-900">AI Content Disclaimer</p>
            </button>
            <button onClick={() => toggleSection(10)} className="text-left p-3 bg-indigo-50 rounded-lg hover:bg-indigo-100 transition-colors">
              <p className="text-sm font-semibold text-indigo-900">Governing Law</p>
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 pb-12">
        {/* Acceptance of Terms */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-6 border border-gray-100">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
              <CheckCircle className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">1. Acceptance of Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                By accessing or using IEEE Paper Pro ("the Service"), you agree to be bound by 
                these Terms of Service and all applicable laws and regulations. If you do not 
                agree with any of these terms, you are prohibited from using the Service.
              </p>
            </div>
          </div>
        </div>

        {/* Service Description */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200 hover:shadow-xl transition-shadow duration-300 mb-4">
          <button
            onClick={() => toggleSection(2)}
            className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                <FileText className="w-5 h-5 text-blue-600" />
              </div>
              <h2 className="text-xl font-bold text-gray-900">2. Service Description</h2>
            </div>
            {expandedSection === 2 ? (
              <ChevronUp className="w-5 h-5 text-gray-400" />
            ) : (
              <ChevronDown className="w-5 h-5 text-gray-400" />
            )}
          </button>
          {expandedSection === 2 && (
            <div className="px-6 pb-6 border-t border-gray-100 pt-6 animate-fadeIn">
              <p className="text-gray-700 mb-4">
                IEEE Paper Pro provides an online platform for generating, formatting, and 
                managing academic research papers in IEEE format. The Service includes:
              </p>
              <div className="grid md:grid-cols-2 gap-3">
                <div className="flex items-start gap-2 p-3 bg-blue-50 rounded-lg">
                  <CheckCircle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">Academic paper generation and formatting tools</span>
                </div>
                <div className="flex items-start gap-2 p-3 bg-blue-50 rounded-lg">
                  <CheckCircle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">AI-powered content assistance</span>
                </div>
                <div className="flex items-start gap-2 p-3 bg-blue-50 rounded-lg">
                  <CheckCircle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">Plagiarism checking services</span>
                </div>
                <div className="flex items-start gap-2 p-3 bg-blue-50 rounded-lg">
                  <CheckCircle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">Document storage and management</span>
                </div>
                <div className="flex items-start gap-2 p-3 bg-blue-50 rounded-lg md:col-span-2">
                  <CheckCircle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">Collaboration features</span>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* User Accounts */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200 hover:shadow-xl transition-shadow duration-300 mb-4">
          <button
            onClick={() => toggleSection(3)}
            className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                <Users className="w-5 h-5 text-purple-600" />
              </div>
              <h2 className="text-xl font-bold text-gray-900">3. User Accounts</h2>
            </div>
            {expandedSection === 3 ? (
              <ChevronUp className="w-5 h-5 text-gray-400" />
            ) : (
              <ChevronDown className="w-5 h-5 text-gray-400" />
            )}
          </button>
          {expandedSection === 3 && (
            <div className="px-6 pb-6 border-t border-gray-100 pt-6 animate-fadeIn">
              <div className="space-y-4">
                <div className="bg-purple-50 rounded-lg p-4 border border-purple-200">
                  <h3 className="font-bold text-purple-900 mb-2">3.1 Registration</h3>
                  <p className="text-purple-800 text-sm">
                    You must create an account to access premium features. You are responsible 
                    for maintaining the confidentiality of your account credentials.
                  </p>
                </div>
                <div className="bg-purple-50 rounded-lg p-4 border border-purple-200">
                  <h3 className="font-bold text-purple-900 mb-2">3.2 Eligibility</h3>
                  <p className="text-purple-800 text-sm">
                    You must be at least 18 years old or have parental consent to use the Service. 
                    By using the Service, you represent that you meet these requirements.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Subscription and Payments */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200 hover:shadow-xl transition-shadow duration-300 mb-4">
          <button
            onClick={() => toggleSection(4)}
            className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                <CreditCard className="w-5 h-5 text-green-600" />
              </div>
              <h2 className="text-xl font-bold text-gray-900">4. Subscription and Payments</h2>
            </div>
            {expandedSection === 4 ? (
              <ChevronUp className="w-5 h-5 text-gray-400" />
            ) : (
              <ChevronDown className="w-5 h-5 text-gray-400" />
            )}
          </button>
          {expandedSection === 4 && (
            <div className="px-6 pb-6 border-t border-gray-100 pt-6 animate-fadeIn">
              <div className="bg-green-50 border-2 border-green-300 rounded-lg p-5 mb-4">
                <h3 className="font-bold text-green-900 mb-3 flex items-center gap-2">
                  <Info className="w-5 h-5" />
                  Payment Terms
                </h3>
                <div className="grid md:grid-cols-2 gap-3">
                  <div className="flex items-start gap-2">
                    <CheckCircle className="w-4 h-4 text-green-700 mt-1 flex-shrink-0" />
                    <span className="text-sm text-green-800">All payments in Indian Rupees (₹)</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <CheckCircle className="w-4 h-4 text-green-700 mt-1 flex-shrink-0" />
                    <span className="text-sm text-green-800">Subscriptions auto-renew unless canceled</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <CheckCircle className="w-4 h-4 text-green-700 mt-1 flex-shrink-0" />
                    <span className="text-sm text-green-800">No refunds for partial periods</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <CheckCircle className="w-4 h-4 text-green-700 mt-1 flex-shrink-0" />
                    <span className="text-sm text-green-800">30 days notice for price changes</span>
                  </div>
                </div>
              </div>
              <div className="space-y-3">
                <div className="p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">4.1 Free Tier</h4>
                  <p className="text-sm text-gray-700">
                    Basic features are available free of charge. Free users acknowledge that 
                    certain advanced features require subscription.
                  </p>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">4.2 Paid Subscriptions</h4>
                  <p className="text-sm text-gray-700">
                    Premium features require payment. By subscribing, you authorize us to 
                    charge your payment method on a recurring basis.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Intellectual Property - Highlighted */}
        <div className="bg-gradient-to-br from-indigo-600 to-purple-600 rounded-2xl shadow-2xl p-8 mb-6 text-white">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
              <Shield className="w-6 h-6 text-white" />
            </div>
            <div>
              <h2 className="text-2xl font-bold mb-4">5. Intellectual Property Rights</h2>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-5 mb-4 border border-white/20">
                <h3 className="font-bold text-white mb-2 flex items-center gap-2">
                  <CheckCircle className="w-5 h-5" />
                  User Content Ownership
                </h3>
                <p className="text-white/90 leading-relaxed">
                  You retain all intellectual property rights to the academic content you 
                  create using our Service. We do not claim ownership over your research 
                  papers, data, or original content.
                </p>
              </div>
              <div className="space-y-3">
                <div className="p-4 bg-white/5 rounded-lg">
                  <h4 className="font-semibold text-white mb-2">5.1 User Grant</h4>
                  <p className="text-sm text-white/90">
                    By using the Service, you grant us a worldwide, non-exclusive, royalty-free 
                    license to use, store, and display your content solely for the purpose of 
                    providing the Service to you.
                  </p>
                </div>
                <div className="p-4 bg-white/5 rounded-lg">
                  <h4 className="font-semibold text-white mb-2">5.2 Service IP</h4>
                  <p className="text-sm text-white/90">
                    All rights, title, and interest in the Service, including software, 
                    algorithms, and platform technology, remain our exclusive property.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* User Responsibilities */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200 hover:shadow-xl transition-shadow duration-300 mb-4">
          <button
            onClick={() => toggleSection(6)}
            className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center">
                <BookOpen className="w-5 h-5 text-amber-600" />
              </div>
              <h2 className="text-xl font-bold text-gray-900">6. User Responsibilities</h2>
            </div>
            {expandedSection === 6 ? (
              <ChevronUp className="w-5 h-5 text-gray-400" />
            ) : (
              <ChevronDown className="w-5 h-5 text-gray-400" />
            )}
          </button>
          {expandedSection === 6 && (
            <div className="px-6 pb-6 border-t border-gray-100 pt-6 animate-fadeIn">
              <div className="space-y-4">
                <div className="bg-amber-50 rounded-lg p-4 border border-amber-200">
                  <h3 className="font-bold text-amber-900 mb-2">6.1 Academic Integrity</h3>
                  <p className="text-amber-800 text-sm">
                    You are solely responsible for ensuring your academic work complies with 
                    institutional policies and maintains academic integrity. The Service is 
                    a tool to assist research, not replace original work.
                  </p>
                </div>
                <div className="bg-red-50 rounded-lg p-4 border border-red-200">
                  <h3 className="font-bold text-red-900 mb-3 flex items-center gap-2">
                    <Ban className="w-5 h-5" />
                    6.2 Prohibited Uses
                  </h3>
                  <p className="text-red-800 text-sm mb-3">You agree not to use the Service for:</p>
                  <div className="space-y-2">
                    <div className="flex items-start gap-2">
                      <XCircle className="w-4 h-4 text-red-600 mt-0.5 flex-shrink-0" />
                      <span className="text-sm text-red-800">Academic dishonesty or plagiarism</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <XCircle className="w-4 h-4 text-red-600 mt-0.5 flex-shrink-0" />
                      <span className="text-sm text-red-800">Creating content that infringes on others' rights</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <XCircle className="w-4 h-4 text-red-600 mt-0.5 flex-shrink-0" />
                      <span className="text-sm text-red-800">Illegal or unauthorized purposes</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <XCircle className="w-4 h-4 text-red-600 mt-0.5 flex-shrink-0" />
                      <span className="text-sm text-red-800">Spamming or unauthorized commercial use</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <XCircle className="w-4 h-4 text-red-600 mt-0.5 flex-shrink-0" />
                      <span className="text-sm text-red-800">Reverse engineering or hacking the Service</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* AI Content Disclaimer */}
        <div className="bg-yellow-50 border-2 border-yellow-400 rounded-2xl shadow-xl p-8 mb-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0">
              <AlertTriangle className="w-6 h-6 text-white" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-yellow-900 mb-3">7. AI Content Disclaimer</h2>
              <div className="bg-yellow-100 rounded-lg p-4 border border-yellow-300">
                <h3 className="font-bold text-yellow-900 mb-2">Important Notice</h3>
                <p className="text-yellow-800 leading-relaxed">
                  AI-generated content may contain inaccuracies. You are responsible for 
                  verifying all AI-generated content and ensuring it meets academic standards 
                  and institutional requirements.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Governing Law */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200 hover:shadow-xl transition-shadow duration-300 mb-6">
          <button
            onClick={() => toggleSection(10)}
            className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center">
                <Gavel className="w-5 h-5 text-indigo-600" />
              </div>
              <h2 className="text-xl font-bold text-gray-900">10. Governing Law and Disputes</h2>
            </div>
            {expandedSection === 10 ? (
              <ChevronUp className="w-5 h-5 text-gray-400" />
            ) : (
              <ChevronDown className="w-5 h-5 text-gray-400" />
            )}
          </button>
          {expandedSection === 10 && (
            <div className="px-6 pb-6 border-t border-gray-100 pt-6 animate-fadeIn">
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  These Terms shall be governed by the laws of India. Any disputes shall be 
                  subject to the exclusive jurisdiction of the courts in Nagpur, Maharashtra.
                </p>
                <div className="bg-indigo-50 rounded-lg p-4 border border-indigo-200">
                  <p className="text-indigo-800 text-sm">
                    In case of any dispute, the parties shall first attempt to resolve it through 
                    mutual discussion. If unresolved, the dispute shall be referred to arbitration 
                    in Nagpur under the Arbitration and Conciliation Act, 1996.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Contact Card */}
        <div className="bg-gradient-to-r from-slate-700 via-gray-800 to-blue-700 rounded-2xl p-8 text-white shadow-2xl">
          <div className="text-center">
            <Mail className="w-12 h-12 mx-auto mb-4" />
            <h3 className="text-2xl font-bold mb-2">Questions About Terms?</h3>
            <p className="mb-6 text-white/90">
              Contact our legal team for clarification on any terms or conditions
            </p>
            <div className="space-y-2">
              <a
                href="mailto:legal@ieeepaperpro.com"
                className="inline-block bg-white text-gray-900 px-8 py-3 rounded-full font-bold hover:bg-gray-100 transition-all duration-300 shadow-lg"
              >
                support@ieeeassistant.in
              </a>
              <p className="text-sm text-white/80">
                Nagpur, Maharashtra, India
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-gray-400 mb-2">
            © 2025 IEEE Paper Pro. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm">
            Governed by the laws of India | Jurisdiction: Nagpur, Maharashtra
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;